const category = 'Register with mission';

export default Object.freeze({
  NEXT: Object.freeze({
    category,
    action: 'Next',
    label: 'Button click'
  })
});
